import { Action, State, StateContext, Store } from "@ngxs/store";
import { Injectable } from "@angular/core";
import { LocalizationService } from "src/app/services/localization/localization.service";
import { AlertService } from "src/app/shared/store/alert/alert.service";
import { MappingUtilsService } from "src/app/services/utils/mapping-utils.service";
import { MonthActions } from "./month.actions";
import { MonthService } from "../../services/month.service";
import { Month } from "../../models/month.model";

export class MonthModel {
    public months: Month[];
    public error: string;
  }

  const defaults = {
    months: [],
    error: '',
  };

  @State<MonthModel>({
    name: 'month',
    defaults,
  })
  @Injectable()
  export class MonthState {
    constructor(
      private alertService: AlertService,
      private localizationService: LocalizationService,
      public store: Store,
      private monthService: MonthService
    ) {}

    @Action(MonthActions.GetMonths)
    getMonths(ctx: StateContext<MonthModel>, {}: MonthActions.GetMonths) {
      return this.monthService.getMonths().subscribe({
          next: (response) =>
            ctx.dispatch(new MonthActions.GetMonthsSuccess(response)),
          error: (error) =>
            ctx.dispatch(new MonthActions.GetMonthsFail(error)),
        });
    }

    @Action(MonthActions.GetMonthsSuccess)
    getMonthsSuccess(ctx: StateContext<MonthModel>,
      { months }: MonthActions.GetMonthsSuccess
    ) {
      ctx.patchState({
        months: months
      });
    }

    @Action(MonthActions.GetMonthsFail)
    getMonthsFailed(
      ctx: StateContext<MonthModel>,
      { error }: MonthActions.GetMonthsFail
    ) {
      ctx.patchState({
        error: error,
      });
      MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
    }

    private getTitle() {
      return this.localizationService.translate('months.title');
    }
  }
